enum BrandEnum {
    HOMECREDIT = "HOMECREDIT",
    TESCO = "TESCO",
    TESTSHOP = "TESTSHOP",
    MALL = "MALL",
    CZC = "CZC",
    ALZA = "ALZA",
    COMGATE = "COMGATE",
    HC_OL = "HC_OL",
    HC_MAPP = "HC_MAPP",
    EKIS = "EKIS",
    AUTO_LOUDA = "AUTO_LOUDA",
}

export default BrandEnum;
